var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-custom-black",
    { attrs: { modalId: "modalVerifyEmailLogin", hideTopCloseButton: true } },
    [
      _c("div", { staticClass: "modal-verify-email-login-wrapper" }, [
        _c("div", { staticClass: "modal-verify-email-login-header" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.translate.login.modalVerifyEmail.header) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-verify-email-login-body mt-4" }, [
          _c("p", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.translate.login.modalVerifyEmail.body1) +
                " "
            ),
            _c("span", [_vm._v(_vm._s(_vm.emailToDisplay))]),
            _vm._v(
              _vm._s(_vm.translate.login.modalVerifyEmail.body2) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(" " + _vm._s(_vm.translate.login.modalVerifyEmail.body3))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(" " + _vm._s(_vm.translate.login.modalVerifyEmail.body4))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-verify-email-login-email-form" },
            [
              !_vm.showEmailForm
                ? _c(
                    "span",
                    {
                      staticClass:
                        "modal-verify-email-login-email-form-show-form",
                      on: { click: _vm.showForm }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.translate.login.modalVerifyEmail.usedWrongEmail
                          ) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.showEmailForm
                ? _c(
                    "span",
                    {
                      staticClass: "modal-verify-email-login-email-form-resend",
                      on: { click: _vm.resendVerificationEmail }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.translate.login.modalVerifyEmail.resendEmail
                          ) +
                          "\n                    "
                      ),
                      _vm.emailLoading
                        ? _c("span", {
                            staticClass: "spinner-border spinner-border-sm ml-2"
                          })
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showEmailForm
                ? [
                    _c(
                      "span",
                      {
                        staticClass: "error-input-container",
                        class: { "has-error": _vm.emailTakenError }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newEmail,
                              expression: "newEmail"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "email" },
                          domProps: { value: _vm.newEmail },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newEmail = $event.target.value
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.newEmailInValidFormat && _vm.newEmail
                      ? _c("error-component", {
                          attrs: {
                            message: _vm.translate.login.emailWrongFormat
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.emailTakenError
                      ? _c("error-component", {
                          attrs: { message: _vm.translate.login.emailTaken }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("button-with-loading", {
                      staticClass: "btn btn-secondary mt-3 w-100",
                      attrs: {
                        disabled:
                          !_vm.newEmailInValidFormat || _vm.emailLoading,
                        text:
                          _vm.translate.login.modalVerifyEmail
                            .buttonChangeEmail,
                        loading: _vm.emailLoading
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.changeEmailSubmit($event)
                        }
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.emailSuccess
                ? _c(
                    "div",
                    { staticClass: "modal-verify-email-login-success-msg" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.translate.login.modalVerifyEmail
                              .emailSuccessfullySent
                          ) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-522d7b5c", { render: render, staticRenderFns: staticRenderFns })
  }
}